import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSwap = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M3.223 10H1l3 4 3-4H5.29a7.003 7.003 0 0 1 12.774-1.5l1.731-1A9.003 9.003 0 0 0 3.223 10M12 19a7 7 0 0 0 6.71-5H17l3-4 3 4h-2.223a9.003 9.003 0 0 1-16.572 2.5l1.73-1A7 7 0 0 0 12 19",
		clipRule: "evenodd"
	})
});
export default SvgSwap;
